const toastTemplates = {
  error: "error",
  tooManyRequests: "tooManyRequests",
  accessDenied: "accessDenied",
};

export default toastTemplates;
